// npm
import React from 'react'
import {
  useParams,
} from 'react-router-dom'
import {
   useQuery,
   useQueryClient,
 } from 'react-query'
import {
  CalendarIcon,
  LocationMarkerIcon,
  UsersIcon,
} from '@heroicons/react/solid'

// local
import { getItems } from '../api.js'

// const items = [
//   {
//     id: 1,
//     title: 'Back End Developer',
//     type: 'Full-time',
//     location: 'Remote',
//     department: 'Engineering',
//     closeDate: '2020-01-07',
//     closeDateFull: 'January 7, 2020',
//   },
//   {
//     id: 2,
//     title: 'Front End Developer',
//     type: 'Full-time',
//     location: 'Remote',
//     department: 'Engineering',
//     closeDate: '2020-01-07',
//     closeDateFull: 'January 7, 2020',
//   },
//   {
//     id: 3,
//     title: 'User Interface Designer',
//     type: 'Full-time',
//     location: 'Remote',
//     department: 'Design',
//     closeDate: '2020-01-14',
//     closeDateFull: 'January 14, 2020',
//   },
// ]

const type = {
  url: "URL",
  image: "Image",
}

export default function ItemList() {
  console.log('ItemList')
  const { domainName } = useParams()
  console.log('ItemList - domainName:', domainName)

  // query for items
  const queryClient = useQueryClient()
  const query = useQuery([ 'items', domainName ], () => getItems(domainName), { refetchOnWindowFocus: false })

  if (query.isLoading) {
    return <p>Loading...</p>
  }

  const items = query.data
  console.log('items:', items)

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-md">
      <ul role="list" className="divide-y divide-gray-200">
        {
          items.map(item => (
            <li key={item.id}>
              <a href="#" className="block hover:bg-gray-50">
                <div className="px-4 py-4 sm:px-6">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-medium text-indigo-600 truncate">
                      {
                        ( item.type === 'url' && item.data.url )
                        ||
                        ( item.type === 'image' && item.data.image )
                      }
                    </p>
                    <div className="ml-2 flex-shrink-0 flex">
                      <p className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        { type[item.type] }
                      </p>
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between">
                    <div className="sm:flex">
                      <p className="flex items-center text-sm text-gray-500">
                        <UsersIcon className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                        { 'chilts' }
                      </p>
                      <p className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6">
                        <LocationMarkerIcon className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                        { 'Palmy' }
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                      <CalendarIcon className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                      <p>
                        Added <time dateTime={ item.inserted }>{ item.inserted }</time>
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          )
        )}
      </ul>
    </div>
  )
}



